import React from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by Heli KV2008B and Heli KV2019B machines

export default function TravelerSizeRow({ minProp = 1, maxProp = 3 }) {
   const { handleInputRangeChange, onChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const traveler1 = machineSetup.extendedPropertyJson?.traveler1 || false;
   const traveler2 = machineSetup.extendedPropertyJson?.traveler2 || false;
   const traveler3 = machineSetup.extendedPropertyJson?.traveler3 || false;
   const traveler4 = machineSetup.extendedPropertyJson?.traveler4 || false;
   const traveler5 = machineSetup.extendedPropertyJson?.traveler5 || false;
   const traveler6 = machineSetup.extendedPropertyJson?.traveler6 || false;
   const traveler7 = machineSetup.extendedPropertyJson?.traveler7 || false;
   const traveler8 = machineSetup.extendedPropertyJson?.traveler8 || false;
   const traveler9 = machineSetup.extendedPropertyJson?.traveler9 || false;

   const travelerQty1 = machineSetup.extendedPropertyJson?.travelerQty1 || "";
   const travelerQty2 = machineSetup.extendedPropertyJson?.travelerQty2 || "";
   const travelerQty3 = machineSetup.extendedPropertyJson?.travelerQty3 || "";
   const travelerQty4 = machineSetup.extendedPropertyJson?.travelerQty4 || "";
   const travelerQty5 = machineSetup.extendedPropertyJson?.travelerQty5 || "";
   const travelerQty6 = machineSetup.extendedPropertyJson?.travelerQty6 || "";
   const travelerQty7 = machineSetup.extendedPropertyJson?.travelerQty7 || "";
   const travelerQty8 = machineSetup.extendedPropertyJson?.travelerQty8 || "";
   const travelerQty9 = machineSetup.extendedPropertyJson?.travelerQty9 || "";

   const defaultOnChangeVal = { target: { value: "" } };

   return (
      <>
         <Row className="mb-2 mt-3">
            <ColPrompt
               title={
                  <span>
                     Traveler Size
                     <br />
                     {"(Check all that apply)"}
                  </span>
               }
               bold={true}
               description={""}
               sizeProp={3}
            />
            <ColValue size={6}>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler1}
                                 onChange={() => onChange("extendedPropertyJson.traveler1", !traveler1)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; GE-72-C-LEMON
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="text-end fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type={"text"}
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty1}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty1", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty1", true)
                              }
                              disabled={!traveler1}
                           />
                           {errorDivDefinitions?.["travelerQty1"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler2}
                                 onChange={() => onChange("extendedPropertyJson.traveler2", !traveler2)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; GE-37-C-RED
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty2}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty2", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty2", true)
                              }
                              disabled={!traveler2}
                           />
                           {errorDivDefinitions?.["travelerQty2"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler3}
                                 onChange={() => onChange("extendedPropertyJson.traveler3", !traveler3)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; GE-90-C-LEMON
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty3}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty3", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty3", true)
                              }
                              disabled={!traveler3}
                           />
                           {errorDivDefinitions?.["travelerQty3"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler4}
                                 onChange={() => onChange("extendedPropertyJson.traveler4", !traveler4)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; GE-25-C-VIOLET
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty4}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty4", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty4", true)
                              }
                              disabled={!traveler4}
                           />
                           {errorDivDefinitions?.["travelerQty4"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler5}
                                 onChange={() => onChange("extendedPropertyJson.traveler5", !traveler5)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; GE-18-C-ORANGE
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty5}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty5", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty5", true)
                              }
                              disabled={!traveler5}
                           />
                           {errorDivDefinitions?.["travelerQty5"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler6}
                                 onChange={() => onChange("extendedPropertyJson.traveler6", !traveler6)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; GE-118-C-BROWN
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty6}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty6", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty6", true)
                              }
                              disabled={!traveler6}
                           />
                           {errorDivDefinitions?.["travelerQty6"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler7}
                                 onChange={() => onChange("extendedPropertyJson.traveler7", !traveler7)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; GE-155-C-NATURAL
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty7}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty7", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty7", true)
                              }
                              disabled={!traveler7}
                           />
                           {errorDivDefinitions?.["travelerQty7"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler8}
                                 onChange={() => onChange("extendedPropertyJson.traveler8", !traveler8)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; GE-163-C-LEMON
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty8}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty8", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty8", true)
                              }
                              disabled={!traveler8}
                           />
                           {errorDivDefinitions?.["travelerQty8"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row className="mb-2">
                  <Col>
                     <Row>
                        <Col xxl={{ offset: 2, size: 8 }}>
                           <Label className="float-start">
                              <Input
                                 type="checkbox"
                                 checked={traveler9}
                                 onChange={() => onChange("extendedPropertyJson.traveler9", !traveler9)}
                                 style={{ borderRadius: "10px", fontSize: "14px" }}
                              />
                              &nbsp;&nbsp;&nbsp; GE-110-C-VIOLET
                           </Label>
                        </Col>
                     </Row>
                  </Col>
                  <Col>
                     <Row className="align-items-center">
                        <Col xxl={3} className="text-end">
                           <h5 className="fw-bold">Qty:</h5>
                        </Col>
                        <Col xxl={3} xs={6}>
                           <Input
                              type="text"
                              style={{ borderRadius: "10px", fontSize: "14px" }}
                              value={travelerQty9}
                              onChange={(e) =>
                                 e.target.value
                                    ? handleInputRangeChange(e, minProp, maxProp, "travelerQty9", true)
                                    : handleInputRangeChange(defaultOnChangeVal, minProp, maxProp, "travelerQty9", true)
                              }
                              disabled={!traveler9}
                           />
                           {errorDivDefinitions?.["travelerQty9"] && (
                              <ErrorDiv>1-3 only</ErrorDiv>
                           )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </ColValue>
         </Row>
      </>
   );
}
